import React, { useState } from 'react';
import { Row, Col, Form } from 'reactstrap';
import { useDispatch } from 'react-redux';
import NavigationTitle from 'components/common/navigationTitle';
import CustomButton from '../buttons/customButton';
import { ReactComponent as Voucher } from 'assets/images/icons/voucher.svg';
import { colors } from 'config/colors';
import { useTranslation } from 'react-i18next';
import { useFormik } from "formik"
import * as Yup from "yup";
import CustomizedInput from '../forms/customizedInput';
import { checkVoucher, saveRoomNumber } from 'store/apps/user';
import ReCAPTCHA from 'react-google-recaptcha';
import { updateLoading, updateToastVoucherModal } from 'store/apps/appConfig';
import { useLocation, useNavigate } from 'react-router-dom';

const VoucherModal = ({ closeModal, guestTime, goTo = false }) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const [voucherError, setVoucherError] = useState(false);
  const [voucherErrorMessage, setVoucherErrorMessage] = useState(false);
  const recaptchaRef = React.createRef();
  const location = useLocation();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      code: ''
    },
    validationSchema: Yup.object({
      code: Yup.string()
        .required(t('app.required'))
    }),
    onSubmit: (values, { resetForm }) => {
      dispatch(updateLoading(true));
      recaptchaRef.current.reset()
      recaptchaRef.current.executeAsync().then((token) => {
        let my_captcha_response = window.grecaptcha.getResponse()
        if (my_captcha_response) {
          dispatch(updateLoading(true));
          dispatch(checkVoucher(values?.code))
            .then((res) => {
              dispatch(updateLoading(false));
              if (res.payload?.Error) {
                setVoucherError(true)
                setVoucherErrorMessage(t(`errorsAPI.${res.payload?.Error}`))
                resetForm()
                setTimeout(() => {
                  setVoucherError(false)
                  setVoucherErrorMessage(false);
                }, 2000)
              }
              else {
                if (guestTime) {
                  setVoucherError(true)
                  setVoucherErrorMessage(t(`app.onlyGuestVouchers`))
                  resetForm()
                }
                else {
                  closeModal()
                  dispatch(saveRoomNumber(false))
                  if (goTo) {
                    navigate(goTo)
                  } else if (location?.pathname === "/prices") {
                    setTimeout(() => {
                      dispatch(updateToastVoucherModal(true))
                    }, 800)
                  }
                }
              }
            })
        }
        else {
          setVoucherError(true)
          setVoucherErrorMessage(t(`errorsAPI.0`))
          resetForm()
        }
      })
    }
  });

  return (
    <Row className='h-100'>
      <Form onSubmit={formik.handleSubmit}>
        <Col xs="12" style={{ height: "17.1%" }}>
          <NavigationTitle title={t('app.applyVoucher')} path="/home" modal guestTime={guestTime} closeCustomModal={closeModal} icon={<Voucher className='m-0 p-0' style={{ fill: colors?.font, height: "18px", width: "18px" }} />} />
        </Col>
        <Col xs="12" style={{ height: "82.9%" }}>
          <Row className='mt-5'>
            <span className='m-0 p-0 text-3 weight-300'>{t('app.insertVoucherCode')}</span>
          </Row>
          <Row className='mt-3'>
            <CustomizedInput
              id="code"
              name="code"
              type="text"
              inputmode="text"
              error={voucherError || formik.errors.code ? true : false}
              placeholder={t('app.code')}
              onChange={formik.handleChange}
              value={formik.values.code}
              formik={formik}
            />
          </Row>
          <Row style={{ height: "35px" }} className="d-flex align-items-center">
            <span className='m-0 p-0 text-danger text-5 weight-300'>{voucherErrorMessage ? voucherErrorMessage : formik.errors.code}</span>
          </Row>
          <Row>
            <Col xs="12" className='mt-4'>
              <CustomButton
                color="primary"
                label={t('app.confirmVoucherCode')}
                textSize="text-3 weight-300"
                onClick={() => formik.handleSubmit()}
              />
            </Col>
          </Row>
        </Col>
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_CAPTCHA_KEY}
          ref={recaptchaRef}
          size="invisible"
          style={{ display: "none" }}
        />
      </Form>
    </Row>
  );
}

export default VoucherModal;